// frontend/packages/business-console/src/components/media/InsertModeDialog.jsx

import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
} from "@mui/material";

const safe = (v) => (v == null ? "" : String(v));

export default function InsertModeDialog({ open, asset, onClose, onChoose }) {
  const type = useMemo(() => String(asset?.type || "image").toLowerCase(), [asset?.type]);
  const title = useMemo(() => safe(asset?.title) || safe(asset?.blobPath).split("/").pop() || "Selected media", [asset]);

  const defaultHint = type === "video" ? "This is a video. Choose how to insert it." : "Choose how to insert this image.";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Insert media</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" sx={{ fontWeight: 900 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.75, mt: 1 }}>
          {defaultHint}
        </Typography>

        <Stack spacing={1.5} sx={{ mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => onChoose?.("image")}
            disabled={type === "video"}
            sx={{ fontWeight: 900 }}
          >
            Insert as Image (markdown)
          </Button>

          <Button
            variant="contained"
            onClick={() => onChoose?.("video")}
            sx={{ fontWeight: 900 }}
          >
            Insert as Video (&lt;video&gt;)
          </Button>

          <Button
            variant="outlined"
            onClick={() => onChoose?.("link")}
            sx={{ fontWeight: 900 }}
          >
            Insert as Link (cld: token)
          </Button>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}